import React from "react"
import Head from "next/head"
import { useRouter } from "next/router"
import { Default, MetaProps, MetaType, OG } from "."
import { DomainPath } from "../../utils/context"

// Open Graph definitions

export const OpenGraph = (props: MetaProps) => {
  const { featuredImage, title, url, type, description } = props

  const router = useRouter()
  const pageUrl = !url ? `${DomainPath()}${router.asPath}` : url
  const pageTitle = !title ? Default.Tagline : title
  const text = description ? description.replace(/[\r\n]/gm, " ") : Default.Description
  // -----------------------------
  // Opengraph tags — https://ogp.me/
  const opengraph = []

  opengraph.push(
    // og:title
    { key: OG.Title, property: OG.Title, content: pageTitle },
    // og:description
    { key: OG.Description, property: OG.Description, content: text },
    // og:url
    { key: OG.Url, property: OG.Url, content: pageUrl },
    // og:site_name
    { key: OG.SiteName, property: OG.SiteName, content: Default.SiteName },
    // fb:app_id
    { key: OG.FacebookAppId, property: OG.FacebookAppId, content: MetaType.FacebookAppId },
  )

  // og:type
  opengraph.push({ key: OG.Type, property: OG.Type, content: type ? type : Default.Type })

  // og:image
  if (featuredImage) {
    opengraph.push(
      { key: OG.Image, property: OG.Image, content: featuredImage.imgurl },
      { key: OG.ImageAlt, property: OG.ImageAlt, content: featuredImage.imgalt },
      { key: OG.ImageType, property: OG.ImageType, content: MetaType.Image },
    )
    if (featuredImage.imgwidth && featuredImage.imgheight) {
      opengraph.push(
        { key: OG.ImageWidth, property: OG.ImageWidth, content: featuredImage.imgwidth },
        { key: OG.ImageHeight, property: OG.ImageHeight, content: featuredImage.imgheight },
      )
    }
  } else {
    opengraph.push(
      { key: OG.Image, property: OG.Image, content: Default.FeaturedImage },
      { key: OG.ImageAlt, property: OG.ImageAlt, content: Default.FeaturedImageAlt },
      { key: OG.ImageType, property: OG.ImageType, content: MetaType.Image },
    )
    opengraph.push(
      { key: OG.ImageWidth, property: OG.ImageWidth, content: Default.FeaturedImageWidth },
      { key: OG.ImageHeight, property: OG.ImageHeight, content: Default.FeaturedImageHeight },
    )
  }

  const allTags = opengraph.map((item) => (
    <meta data-testid={item.key} key={item.key} property={item.property} content={item.content} />
  ))

  return <Head>{allTags}</Head>
}
